import { useQuery } from '@tanstack/react-query'

import { getSpecialPerformanceDetail } from '~/features/special-performance/apis/specialPerformance'

export const useSpecialPerformanceDetail = (event_ticket_id: string) => {
  return useQuery({
    queryKey: ['event_ticket_id', event_ticket_id],
    queryFn: () => getSpecialPerformanceDetail(event_ticket_id),
  })
}
